import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import { fetchInvitations } from 'store/actions/accounts/invitations/fetchInvitations';
import { deleteInvitation } from 'store/actions/accounts/invitations/deleteInvitations';

const InvitationsList = (props) => {
    const {
        location,
        resource,
    } = props;

    return (
        <ResourceList
            action={ fetchInvitations }
            actionType={ 'INVITATIONS' }
            hidePagination={ true }
            location={ location }
            renderNull
            resource={ resource }
            title='resources.invitations.open_invitations'
        >
            <Table
                colorToggle={ {
                    condition: false,
                    color: 'gray',
                    key: 'is_enabled',
                } }
            >
                <TextField
                    column={ {
                        sortable: false,
                        link: false,
                    } }
                    label={ 'filters.components.email.label' }
                    maxCharacters={ 100 }
                    source='email'
                />

                <DropDownActionsMenu
                    column={ {
                        align: 'center',
                        link: false,
                        width: '10%',
                    } }
                    source='actions'
                >
                    <DeleteAction action={ deleteInvitation } />
                </DropDownActionsMenu>
            </Table>
        </ResourceList>
    );
};

InvitationsList.propTypes = {
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
};

export default InvitationsList;


// WEBPACK FOOTER //
// ./src/pages/invitations/list/InvitationsList.js